import { render } from "./PetCalculatorForm.vue?vue&type=template&id=530aae66"
import script from "./PetCalculatorForm.vue?vue&type=script&lang=js"
export * from "./PetCalculatorForm.vue?vue&type=script&lang=js"

import "./PetCalculatorForm.vue?vue&type=style&index=0&id=530aae66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__